import { gsap, Power3 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import { breakpointDown, breakpointUp } from './utils/breakpoints'
import { runSkew } from './skew-on-scroll'
import { updateUrl } from './utils/updateUrl'

gsap.registerPlugin(ScrollTrigger)

function initSectionAnimations()
{

  if(!$('#hero-sequence').length && !$('body').hasClass('news-page-template')) return

  let navHeader = $('.nav-header')
  let floatingButton = $('.floating-button')
  let menuElement = $('.nav-mobile-view')
  let bgDark = '#0E0E0E'
  let bgLight = '#73A1FF'
  let bgPink = '#73A1FF'
  let bgLightBlue = '#73A1FF'
  let bgDarkBlue = '#0634AE'
  let startTrigger = 'top center'
  let endTrigger = 'bottom center'
  let locoScroller = breakpointUp('lg') ? '.smooth-scroll' : null
  let currentSection = '#hero-sequence'

  gsap.utils.toArray('.section-animate-trigger').forEach(element => {

    let section = $(element).data('section')
    let topSectionAnimate = $(element).data('top-section')
    let bottomSectionAnimate = $(element).data('bottom-section')
    let theme = $(element).data('theme')

    if(breakpointUp('lg')) {
      gsap.set('#categories-sequence .sequence-images', {opacity: 0})
      gsap.set('.jury-navigation-container', {opacity: 0})
    }


    function triggerEnter()
    {
      currentSection = section
      if(breakpointDown('lg') && section === '#mobile-navigation') {
        $('#mobile-button-nav').addClass('floating')
        $('.nav-header').removeClass('light-menu')
      }

      if(breakpointUp('lg')) {


      if(theme) {
        if(theme === 'dark-theme') {
          gsap.to('body', { backgroundColor: bgDark })

        } else if (theme === 'dark-blue-theme') {
          gsap.fromTo('body', { backgroundColor: bgLightBlue }, { backgroundColor: bgDark })

        } else {
          gsap.fromTo('body', {backgroundColor: bgDark}, {backgroundColor: bgLightBlue})
        }
      }


        gsap.fromTo(section + ' .element-animate', {opacity: 0, y: 70}, {opacity: 1, y: 0})

      }


      updateNavElements(element)
      runSkew($(element).data('trigger-skew'))
      //updateUrl($(element).data('url'))
      updateFloatingButton(element)


    }

    function triggerLeave()
    {

      if(breakpointUp('lg') && section !== '#hero-sequence' && section !== '#hero-sequence-bottom') {

        gsap.fromTo(section + ' .element-animate', {opacity: 1}, {opacity: 0, overwrite: 'all'})

      }

    }

    function triggerLeaveBack()
    {

      if(breakpointDown('lg') && section === '#mobile-navigation') {
        $('#mobile-button-nav').removeClass('floating')
      }

      if(breakpointUp('lg') && section !== '#hero-sequence' && section !== '#hero-sequence-bottom') {

        gsap.fromTo(section + ' .element-animate', {opacity: 1}, {opacity: 0, overwrite: 'all'})

        if(section === '#partners') {
          // gsap.fromTo('body, #hero-floating-background, #background-color-check', {backgroundColor: bgLightBlue}, {backgroundColor: bgDark})

          gsap.fromTo(topSectionAnimate, { opacity: 0, y: -70}, { opacity: 1, y: 0})

        }

      }

      updateNavLeaveElements(element)


    }

    function triggerEnterBack()
    {
      currentSection = section

      if(breakpointUp('lg')) {
        //if (section === '#hero-sequence') return false

        if(theme) {

          if (section === '#partners'){
            gsap.fromTo('body', {backgroundColor: bgLight}, {backgroundColor: bgDark})
          } else {

            if (theme === 'dark-theme') {
              gsap.fromTo('body', {backgroundColor: bgLight}, {backgroundColor: bgDark})

            } else if (theme === 'dark-blue-theme') {
              gsap.fromTo('body', {backgroundColor: bgLightBlue}, {backgroundColor: bgDark})

            } else {
              gsap.fromTo('body', {backgroundColor: bgDark}, {backgroundColor: bgLight})
            }

          }

        }


        gsap.fromTo(section + ' .element-animate', {opacity: 0, y: -70}, {opacity: 1, y: 0})

      }

      updateNavElements(element)
      runSkew($(element).data('trigger-skew'))
      //updateUrl($(element).data('url'))
      updateFloatingButton(element)
    }


    function updateNavElements(element)
    {
      if(breakpointUp('lg')) {

        if ($(element).data('menu-theme')) {
          navHeader.removeClass('dark-menu').removeClass('dark-menu-nav').removeClass('light-menu').addClass($(element).data('menu-theme'))
        }

		if( $(element).data('logo-theme')) {
			navHeader.removeClass('dark-logo').removeClass('light-logo').addClass($(element).data('logo-theme'))
		}
		  
        if ($(element).data('scroll-theme')) {
          navHeader.removeClass('dark-scroll').removeClass('light-scroll').removeClass('white-scroll').addClass($(element).data('scroll-theme'))
        }

        if($(element).data('hide-scroll') === 1) {
          $('.nav-header .live-scroll').addClass('hidden')

        } else {
          $('.nav-header .live-scroll').removeClass('hidden')
        }

      }

    }

    function updateNavLeaveElements(element)
    {
      if(breakpointUp('lg')) {

        if($(element).data('menu-back-theme')) {
          navHeader.removeClass('dark-menu').removeClass('dark-menu-nav').removeClass('light-menu').addClass($(element).data('menu-back-theme'))
        }

        if($(element).data('scroll-back-theme')) {
          navHeader.removeClass('dark-scroll').removeClass('light-scroll').addClass($(element).data('scroll-back-theme'))
        }

      }

    }

    function updateFloatingButton(element)
    {
      if(breakpointDown('md')) {
        parseInt($(element).data('floating-button')) === 1 ? floatingButton.removeClass('hidden') : floatingButton.addClass('hidden')
      }
    }


    ScrollTrigger.create({
      trigger: element,
      scroller: locoScroller,
      start: startTrigger,
      end: endTrigger,
      scrub: true,
      onEnter: triggerEnter,
      onEnterBack: triggerEnterBack,
      onLeave: triggerLeave,
      onLeaveBack: triggerLeaveBack,
      onUpdate() {
        if(breakpointUp('lg')) {
          if (currentSection === '#categories-sequence' && $('body').attr('style') === 'background-color: #73A1FF;') {
            $('#categories-sequence .sequence-images').addClass('animating').css('opacity', 1)
          } else {
            $('#categories-sequence .sequence-images').removeClass('animating').css('opacity', 0)
          }

          if (currentSection === '#partners') {
            $('.hero-images-holder').css('opacity', 0).removeClass('animating')
          }

          if (currentSection === '#jury' ) {
            $('.jury-navigation-container').addClass('animating').css('opacity', 1)
          } else {
            $('.jury-navigation-container').removeClass('animating').css('opacity', 0)
          }

        }

      },
      //markers: true
    })

  })

}


export { initSectionAnimations }
